import { mapGetters, mapActions } from 'vuex';
import { GlossaryApi } from '@gslc/models';
import { openApiConfig } from '@/api/config';
import { SEGMENT_EVENTS } from '@/constants';

const config = openApiConfig();
const glossaryApi = new GlossaryApi(config);

export default {
  computed: {
    ...mapGetters([
      'glossaries',
      'glossaryLoading',
      'glossarySearch',
      'glossarySearchIsLetter',
    ]),
    mx$glossaryLength() {
      return this.glossaries.filter(item => item && item.name).length;
    },
    mx$glossaryItems() {
      if (!this.glossaries.length) {
        return [];
      }
      const data = this.glossaries.reduce((r, e) => {
        // get first letter of name of current element
        let name = '';
        if (e && e.name && e.name.length > 0) {
          name = e.name[0];
        } else {
          return r;
        }
        if (!isNaN(name)) {
          name = '0-9';
        }
        // if there is no property in accumulator with this letter create it
        if (!r[name]) r[name] = { name, contents: [e] };
        // if there is push current element to children array for that letter
        else r[name].contents.push(e);
        // return accumulator
        return r;
      }, {});
      const result = Object.values(data);
      return result.map(item => ({
        ...item,
        contents: item.contents.sort((a, b) => {
          if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
            return -1;
          }
          if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) {
            return 1;
          }
          return 0;
        }),
      }));
    },
  },
  created() {
    //
  },
  methods: {
    ...mapActions([
      'setGlossaries',
      'setGlossaryLoading',
      'setGlossarySearch',
      'setGlossarySearchIsLetter',
    ]),
    async mx$fetchGlossaries() {
      try {
        this.setGlossaryLoading(true);
        this.setGlossaries([]);

        let glossaryResponse = null;
        const accessToken = await this.$auth.getTokenSilently();
        if (!this.glossarySearch) {
          glossaryResponse = await glossaryApi
            .getGlossary({
              headers: { Authorization: `Bearer ${accessToken}` },
            })
            .catch(e => console.error(e));
        } else {
          glossaryResponse = await glossaryApi
            .searchGlossary(this.glossarySearch, this.glossarySearchIsLetter, {
              headers: { Authorization: `Bearer ${accessToken}` },
            })
            .catch(e => console.error(e));
        }

        const data = glossaryResponse?.data?.data ?? [];
        this.setGlossaries(data);
      } catch (error) {
        console.log(error);
      } finally {
        this.setGlossaryLoading(false);
      }
    },
  },
};
